const FAILURE_THRESHOLD = 2;

const listeners = new Set();
let consecutiveFailures = 0;

export function isBackendUnreachableError(error) {
  if (!error || error.code === 'ERR_CANCELED') {
    return false;
  }

  if (error.code === 'ECONNABORTED' || error.code === 'ERR_NETWORK') {
    return true;
  }

  if (!error.response) {
    return Boolean(error.request);
  }

  return [502, 503, 504].includes(error.response.status);
}

function emit(isDown) {
  listeners.forEach((listener) => listener({ isDown }));
}

export function notifyBackendFailure({ immediate = false } = {}) {
  consecutiveFailures = immediate
    ? FAILURE_THRESHOLD
    : consecutiveFailures + 1;

  if (consecutiveFailures >= FAILURE_THRESHOLD) {
    emit(true);
  }
}

export function notifyBackendSuccess() {
  const wasDown = consecutiveFailures >= FAILURE_THRESHOLD;
  consecutiveFailures = 0;
  if (wasDown) {
    emit(false);
  }
}

export function subscribeBackendStatus(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
